export default "__VITE_ASSET__5f725171__"